import React, { useEffect } from "react";
import Loading from ".././Loading"; // Use o seu componente de Loading
import { generateCodeVerifier, generateCodeChallenge } from "../../../shared-api/helpers/pkce";
import { Environment } from "../../../shared-api/helpers/Environment";
import {Endpoints} from "../../../mtlogin-api/Endpoints";

export const LoginInitiator = () => {
    useEffect(() => {
        const iniciarLogin = async () => {
            // 1. Gera a chave e o cadeado
            const verifier = await generateCodeVerifier();
            const challenge = await generateCodeChallenge(verifier);

            // 2. Guarda a chave para a volta
            sessionStorage.setItem('pkce_code_verifier', verifier);
            
            const loginUrl = new URL(Endpoints.URL_LOGIN_MT);
            loginUrl.searchParams.append('code_challenge', challenge);
            loginUrl.searchParams.append('code_challenge_method', 'S256');

            //console.log("url redirecionada para mt login: ",loginUrl.toString());

            // 4. Redireciona
            window.location.replace(loginUrl.toString());
        };

        iniciarLogin();
    }, []);

    return <Loading />;
};